import localforage from 'localforage'

import logger from '@/utils/logger'

import type { StorageAPI } from './common'

export default function getBrowserStorage<T>(key: string): StorageAPI<T> {
  return {
    async get() {
      logger.info('getBrowserStorage.get', { key })
      try {
        return localforage.getItem(key) ?? null
      } catch (_) {
        return null
      }
    },
    async set(value: T): Promise<void> {
      logger.info('getBrowserStorage.set', { key })
      try {
        await localforage.setItem(key, value)
      } catch (_) {
        // No Op
      }
    },
    async del(): Promise<void> {
      logger.info('getBrowserStorage.del', { key })
      try {
        await localforage.removeItem(key)
      } catch (_) {
        // No Op
      }
    },
  }
}
